export default "__VITE_ASSET__CUexhT2s__"